import React, { useEffect, useState } from 'react'

// redux
import { connect } from "react-redux";

// styles
import { PerPageContainer } from '../../../../styles/Themes/StylesTheme1/MyAccountStyles'
import { OrdersContainer } from '../../../../styles/Themes/StylesTheme1/OrdersStyles'

// redux actions
import { setGlobalLoading } from 'redux/actions/actionCommon';

// components
import MyAccountLeftBar from '../../../../Themes/MyAccountTheme1/includes/MyAccountLeftBar'

// order types componets
import AllOrders from './includes/AllOrders'
import CompletedOrders from './includes/CompletedOrders';
import PendingOrders from './includes/PendingOrders';


function Orders(props) {
    // props
    const {
        parentProps,

        setGlobalLoading,

        currentPath
    } = props

    // states
    const [currentOrderType, setCurrentOrderType] = useState("")

    // checking current route
    useEffect(() => {
        if (parentProps?.match?.params?.orderType) {
            // setting global loading
            setGlobalLoading(true)

            // setting current route
            setCurrentOrderType(parentProps.match.params.orderType)

            // setting global loading
            setGlobalLoading(false)
        }
    }, [parentProps.match.params.orderType])

    return (
        <PerPageContainer>
            <div className="container">
                <div className="per-page-container-inner d-md-flex flex-wrap align-items-start">
                    <MyAccountLeftBar />

                    <OrdersContainer className="media-body position-relative">
                        {
                            currentOrderType === "all-orders" ? (
                                <AllOrders
                                    currentPath={currentPath}
                                />
                            ) : null
                        }
                        {
                            currentOrderType === "pending-orders" ? (
                                <PendingOrders
                                    currentPath={currentPath}
                                />
                            ) : null
                        }
                        {
                            currentOrderType === "completed-orders" ? (
                                <CompletedOrders
                                    currentPath={currentPath}
                                />
                            ) : null
                        }
                    </OrdersContainer>
                </div>
            </div>
        </PerPageContainer >
    )
}


const getDataFromStore = (state) => {
    return {
    };
};

const dispatchActionsToProps = (dispatch) => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    };
};

export default connect(getDataFromStore, dispatchActionsToProps)(Orders);